import { useMemo } from 'react'

export function getActiveAgentQuestion(messages) {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i]
    if (message?.role === 'assistant' && message.agentQuestion?.status === 'open') {
      return { ...message.agentQuestion, messageId: message.id }
    }
  }
  return null
}

export function useActiveAgentQuestion(messages) {
  return useMemo(() => getActiveAgentQuestion(messages ?? []), [messages])
}
